// extracted by mini-css-extract-plugin
export default {"fullHeight":"style-module--full-height--7b88f","breadcrumb":"style-module--breadcrumb--02364"};